export default "__VITE_ASSET__DIOXWYPr__"